/**
 * 模块 - 代理商服务商 - 英文
 */
export default {
  agentProvider: {
    application: 'Agent Service Provider Application',
    applicationEdit: 'Agent Service Provider Edit',
    agent: 'Agent',
    agentType: 'Agent Type',
    period: 'Period',
    status: 'Status',
    bufferPeriod: 'Buffer Period',
    shareholdingRatio: 'Equity Ratio',
    remark: 'Remark',
    subscribeRegion: 'Subscription Region',
    totalAmount: 'Total Amount',
    periodEndTime: 'Period End Time',
    pleaseSelectAgent: 'Select agent',
    pleaseSelectAgentType: 'Select agent type',
    pleaseSelectPeriod: 'Select period',
    pleaseSelectStatus: 'Select status',
    pleaseEnterAmount: 'Enter total amount',
    pleaseEnterBufferPeriod: 'Enter buffer period',
    pleaseEnterShareholdingRatio: 'Enter equity ratio',
    pleaseEnterRemark: 'Enter remark',
    pleaseSelectRegion: 'Select province/city/district',
    campusId: 'Agent ID',
    campusName: 'Agent Name',
    districts: 'Selected Region',
    agentTypeName: 'Agent Type',
    amount: 'Total Payment',
    rechargeAmount: 'Paid Amount',
    paidAmount: 'Total Paid Order Amount',
    goldAmount: 'Remaining Unordered Amount',
    retainAmount: 'Retention Amount',
    openStatusName: 'Status',
    shareholdingRatioName: 'Equity Ratio',
    periodDateText: 'Period',
    bufferPeriodName: 'Buffer Period',
    to: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    // OrganizationManage search form
    orgTypeLabel: 'Organization Type:',
    pleaseSelectOrgType: 'Select organization type',
    orgLocationLabel: 'Location:',
    pleaseSelectOrgLocation: 'Select location',
    signTimeLabel: 'Sign Time:',
    pieceNameLabel: 'Area Name:',
    pleaseEnterPieceName: 'Enter area name',
    createTimeLabel: 'Create Time:',
    contractStatusLabel: 'Contract Status:',
    pleaseSelectContractStatus: 'Select contract status',
    handStatusLabel: 'Handover Status:',
    pleaseSelectHandStatus: 'Select handover status',
    openStatusLabel: 'Open Status:',
    pleaseSelectOpenStatus: 'Select open status',
    openTimeLabel: 'Open Time:',
    creatorLabel: 'Creator:',
    pleaseSelectCreator: 'Select creator',
    pleaseSelectOperator: 'Select operator',
    chargeStateLabel: 'Charge Status:',
    pleaseSelectChargeState: 'Select charge status',
    chargePlanLabel: 'Charge Plan:',
    pleaseSelectChargePlan: 'Select charge plan',
    isFreeMonthLabel: 'Commission Free:',
    pleaseSelectIsFreeMonth: 'Select commission free status',
    freeEndTimeLabel: 'Commission Free End Time:',
    overallPlannerLabel: 'Overall Planner:',
    pleaseSelectOverallPlanner: 'Select overall planner',
    supportStaffLabel: 'Support Staff:',
    pleaseSelectSupportStaff: 'Select support staff',
    participateTypeLabel: 'HQ Leads Plan:',
    schoolGradeLabel: 'Organization Rating:',
    pleaseSelectSchoolGrade: 'Select organization rating',
    orignSignMainNameLabel: 'Original Entity Name:',
    schoolStatusLabel: 'Organization Account Status:',
    pleaseSelectSchoolStatus: 'Select organization account status',
    campusLabelLabel: 'Organization Label:',
    pleaseSelectCampusLabel: 'Select organization label',
    // OrganizationManage table headers
    orgType: 'Organization Type',
    orgLocation: 'Organization Location',
    signTime: 'Sign Time',
    pieceName: 'Area Name',
    supportStaffName: 'Support',
    contractStatus: 'Contract Status',
    handStatus: 'Handover Status',
    isFreeMonth: 'Commission Free',
    freeTime: 'Commission Free Period',
    chargePlan: 'Charge Plan',
    chargeState: 'Charge Status',
    schoolGrade: 'Organization Rating',
    openStatus: 'Open Status',
    actualOpenTime: 'Open Time',
    schoolStatus: 'Organization Account Status',
    participateType: 'HQ Leads Plan',
    signMainTypeName: 'Sign Type',
    signMainName: 'Sign Entity Name',
    orignSignMainTypeName: 'Original Sign Entity Type',
    orignSignMainName: 'Original Sign Entity Name',
    contactNo: 'Contact Phone',
    idCard: 'ID Card No.',
    address: 'Contact Address',
    refundStatusName: 'Refund Status',
    lastUpdateUserName: 'Last Updated By',
    lastUpdateTime: 'Last Update Time',
    createUserName: 'Created By',
    createTime: 'Create Time',

    // OrganizationManage main page (buttons, quick search, table, dialogs)
    orgInfo: 'Organization Info',
    orgDataReport: 'Organization Data Report',
    batchAdd: 'Batch Add',
    quickSearchPlaceholder: 'Enter org ID, name, sign entity name, or ID card',
    quickSearch: 'Quick Search',
    advancedSearch: 'Advanced Search',
    clearFilter: 'Clear Filter',
    orgIdCol: 'Organization ID',
    orgNameCol: 'Organization Name',
    viewDetail: 'View Detail',
    refund: 'Refund',
    assignCourses: 'Assign Courses',
    areaRelease: 'Area Release',
    operatePine: 'Operate Pine',
    closeOrgAccount: 'Close Organization Account',
    openOrgAccount: 'Open Organization Account',
    batchCreateAgentTitle: 'Batch Create Agent',
    downloadTemplateTip: 'To download template, click:',
    downloadImportTemplate: 'Download Import Template',
    selectFileToImport: 'Select file to import and start',
    dragOrClickUpload: 'Drag file here or',
    clickUpload: 'click to upload',
    importCompleteViewDetail: 'Import complete. Click to view',
    importDetail: 'Import details',
    tip: 'Tip',
    confirmSubmitOrgTip: 'Confirm to submit "{signMainTypeName}-{signMainName}"? You can complete organization info after submit.',
    confirmCloseOrgAccount: 'Confirm to close organization account?',
    confirmOpenOrgAccount: 'Confirm to open organization account?',
    closeOrgAccountDesc1: 'After closing, all staff accounts cannot log in to "Organization Operation System,',
    closeOrgAccountDesc2: 'Principal & Teacher Portal". Student accounts cannot log in to Student Portal.',
    closeReasonLabel: 'Reason for closing:',
    pleaseEnterReason20: 'Enter reason (max 20 characters)',
    openOrgAccountDesc1: 'After opening, all staff accounts can log in to "Organization Operation System,',
    openOrgAccountDesc2: 'Principal & Teacher Portal" again. Student accounts can log in to Student Portal.',
    verifyTip: 'Verification',
    pleaseCheckSms: 'Please check SMS to {phone}',
    pleaseEnterFourDigitCode: 'Enter 4-digit verification code',
    codeSentSuccess: 'Verification code sent',
    codeSendFailed: 'Verification code send failed',
    courseAssignSuccess: 'Courses assigned successfully',
    courseAssignFail: 'Course assignment failed',
    onlyXlsXlsxFormat: 'Only .xls or .xlsx format is supported',
    importFail: 'Import failed',
    submitSuccess: 'Submitted successfully',

    // GoldReCharge
    rechargeNo: 'Serial No.',
    rechargeNoLabel: 'Recharge Serial',
    pleaseEnterRechargeNo: 'Enter recharge serial',
    accountType: 'Account Type',
    pleaseSelectAccountType: 'Select account type',
    createBy: 'Operator',
    rechargeTime: 'Recharge Time',
    payMethod: 'Pay Method',
    goldAccountRechargeRecord: 'Gold Account Recharge Record',
    serviceProviderRights: 'Service Provider Rights',
    goldAccountExpenseRecord: 'Gold Account Expense Record',
    goldAccount: 'Gold Account',
    accountBalance: 'Account Balance',
    yuan: 'yuan',
    totalPaymentAmount: 'Total Payment Amount',
    paidPaymentAmount: 'Paid Payment Amount',
    totalPaidOrderAmount: 'Total Paid Order Amount',
    retainPaymentAmount: 'Retention Amount',
    serviceRegion: 'Service Region',
    retainBalance: 'Retention Balance',
    purchaseProduct: 'Purchase Product',
    purchaseQty: 'Purchase Qty',
    purchaseAmount: 'Purchase Amount',
    goldAccountPayAmount: 'Gold Account Pay Amount',
    voucherAccountPayAmount: 'Voucher Account Pay Amount',
    cashPayAmount: 'Cash Pay Amount',
    payMethodLabel: 'Pay Method',
    lastPayTime: 'Last Pay Time',
    operator: 'Operator',
    voucherBonusAccount: 'Voucher Bonus Account',
    purchaseOrderNo: 'Purchase Order No.',
    payTimeLabel: 'Pay Time',
    rechargeAmount: 'Recharge Amount',
    payTime: 'Recharge Time',
    pleaseSelectAgentLevel: 'Select agent level',
    pleaseEnterReceiverName: 'Enter receiver name',
    pleaseEnterReceiverPhone: 'Enter receiver phone number',
    pleaseEnterReceiverAddress: 'Enter receiver address',
    pleaseEnterDealerId: 'Enter dealer ID',
    pleaseEnterAgentId: 'Enter agent ID',
    pleaseSelectContractType: 'Select contract type',
    pleaseSelectFileType: 'Select file type',
    pleaseSelectCampusNature: 'Select campus nature',
    pleaseEnterCampusName: 'Enter campus name',
    pleaseSelectMaterialType: 'Select material type',
    pleaseSelectInvoiceType: 'Select invoice type',
    ke: 'Assigned Service Staff',
    pleaseSelect: 'Select Campus',
    all: 'All',
    not: 'Not Signed In',
    idle: 'Idle',
    busy: 'Busy',
    adPosition: 'Ad Position',
    name: 'Enter School Name',
    onShelf: 'On Shelf',
    offShelf: 'Off Shelf',
    tai: 'Login Page Static Image',
    loginFloatWindow: 'Login Page Float',
    bu: 'Bottom Float',
    fullscreenPopup: 'Full Screen Popup',
    miniProgramHome: 'Mini Program Home',
    miniProgramSquirrelCup: 'Mini Program Squirrel Cup',
    time: 'Free Draw End Time:',
    type: 'Organization Type:',
    ru: 'Inbound',
    chu: 'Outbound',
    di: 'Location:',
    chuangjian: 'Creator:',
    ji: 'Five Star',
    free: 'Free',
    paid: 'Paid',
    no: 'No',
    normal: 'Normal',
    closed: 'Closed',
    participate: 'Participate',
    notParticipate: 'Not Participate',
    xuexiaoxueduan: 'School Section',
    xue: 'School Nature',
    boardingStatus: 'Boarding Status',
    school: 'Linked Campus',
    public: 'Public',
    private: 'Private',
    international: 'International',
    xuanqu: 'Selected Region',
    tizonge: 'Total Withdrawal Amount',
    order: 'Total Paid Order Amount',
    equityRatio: 'Equity Ratio',
    week: 'Period',
    qi: 'Buffer Period',
    purchase: 'Purchase Order No.',
    recharge: 'Recharge Method:',
    caozuo: 'Operator',
    pleaseEnter: 'Enter Recharge Serial',
    texts319: 'Form',
    textij8y: 'Total Count',
    add: 'Add',
    textruia: 'Form',
    text9iv4: 'Total Count',
    operation: 'Operation',
    textsuxt: 'File',
    textje8x: 'File Name',
    textd6a5: 'Size',
    text5jw7: 'Total Count',
    delete: 'Delete',
    hour: 'Search triggered by component',
    minhour: 'When paginating',
    houryici: 'Use previous params',
    texts3fo: 'File',
    textjrfo: 'DownloadFail',
    textla8q: 'DeleteSuccess',
    textl5ao: 'DeleteFail',
    textykou: 'Unsubscribe',
    textx32p: 'Top Breadcrumb',
    back: 'Back',
    textulqi: 'ContractInformation',
    textdhve: 'Contract Basic Info',
    textp0hg: 'AgentInformation',
    textr0jm: 'Agent Initial Account Amount',
    text03wh: 'Contract Basic Info',
    textt23v: 'Other File Signing Info',
    text83nw: 'OrderInformation',
    textiyu2: 'Invoice Info',
    textdat4: 'Organization Info',
    textnpnc: 'Campus Entity',
    hao: 'Account Info',
    text7kqa: 'ContactInformation',
    text77h0: 'Campus Basic Info',
    textj19e: 'Textbook Version Info',
    textujbu: 'Campus Device Info',
    textchvw: 'Pricing & System Info',
    texttdzq: 'Material Info',
    textccuo: 'Output',
    textykpz: 'Organization Contract Info',
    textatrk: 'Organization Basic Info',
    textxdk4: 'Organization Details',
    textmjfd: 'Device Info',
    textjqma: 'Initial Amount',
    textjfhw: 'Contract Dept',
    textjku3: 'Coordinating Dept',
    textmffo: 'New',
    edit: 'Edit',
    preview: 'Preview',
    textwhr8: 'Invoice or Not',
    texthy28: 'Expand Contract Info',
    textmds2: 'Expand Organization Info',
    textb1hd: 'Campus Whether',
    texte1p3: 'In Gray Campus',
    text5k7q: 'Dev Test',
    text5ozx: 'Get Invoice Default',
    textjhfo: 'Get',
    textjac1: 'Get Organization Formal',
    textkve0: 'Get Squirrel Organization',
    textaiw3: 'Get Detail Address',
    textrnkn: 'Organization Type',
    texts52f: 'Get Organization Name',
    textjeun: 'Get Organization Type',
    textd5or: 'Expand/Collapse Contract',
    yi: 'Back',
    textmkpt: 'SignInformation',
    signingEntity: 'Signing Entity',
    texta293: 'Individual',
    textqrvk: 'Legal Person Name',
    textqrpg: 'Contact Email',
    text0qu2: 'Signer Address',
    text79cm: 'Multi-Campus Query',
    textcfao: 'Signing Entity Change Status',
    textpsfg: 'Unchanged',
    texthtif: 'Changed',
    text8f1k: 'Change Details',
    text91mm: 'Business License',
    text20hu: 'Click to View',
    texthcwv: 'Contact',
    textfa0i: 'Multi-Campus',
    text9hud: 'Location',
    text0fdp: 'ContractStatus',
    textdst0: 'Discount Contract',
    text41xd: 'Equity Amount',
    textpze9: 'Contract Manager',
    textc148: 'Regional Standard',
    signAmount: 'Sign Amount',
    textb7f1: 'Received Amount',
    texta9pu: 'Free Draw Period',
    month: 'Month(s)',
    textenfo: 'Site Selection Staff',
    marketSubsidyFee: 'Market Subsidy Fee',
    textf1tq: 'Regional Standard Desc',
    text739o: 'Contract Area Name',
    textwjlv: 'Contract Deposit',
    textey7d: 'Preparation Period',
    text61bh: 'Campus Tag',
    textpavs: 'ContractInformation',
    text3pv0: 'Contract Attachment',
    textgk5w: 'Other File Signing Info',
    textzeij: 'Attachment',
    download: 'Download',
    textb0ke: 'OrderInformation',
    textgdcv: 'Invoice Info',
    textkwte: 'RefundInformation',
    text89j4: 'Total Refund',
    textfib2: 'Actual Refund',
    text057g: 'Refund Method',
    yihour: 'First Payout Time',
    textuki5: 'Refund Period',
    textsosh: 'Deduction Amount',
    text4s0r: 'Refund Reason',
    textxil0: 'Convert Option',
    textbwlu: 'Payment Status',
    erhour: 'Second Payout Time',
    textbccd: 'Area Release',
    texte2qc: 'Release Status',
    textx43c: 'Payout Status',
    text3d6g: 'Payout Period',
    textuag3: 'Payout Info',
    textvj4l: 'Released Campus Info',
    text61e8: 'Multi-Campus Dialog',
    text03kt: 'Change Details Dialog',
    texte4i4: 'Output',
    campus: 'Campus',
    textzt0d: 'Signing EntityType',
    textt5tl: 'SignName',
    textnicu: 'Change Reason',
    textq8j4: 'TypeContract',
    text1wvm: 'ContractName',
    contractCode: 'Contract Code',
    text0z7q: 'ContractAmount',
    textvnxs: 'Contract Manager',
    creator: 'Creator',
    textisrt: 'Modifier',
    textzc5z: 'File Type',
    text3bk2: 'File Purpose',
    text744a: 'File Signing Manager',
    customerName: 'Customer Name',
    mobile: 'Mobile',
    textkg1z: 'OrderStatus',
    textox83: 'OrderAmount',
    text757y: 'Deposit',
    textiikg: 'Received Amount',
    texty5vn: 'Source',
    text48iv: 'Invoice Type',
    textr252: 'Invoice Amount',
    text8lmk: 'Invoice Title',
    textsgpq: 'RefundAmount',
    texts2wm: 'Payout Amount',
    text5l9n: 'Released Campus',
    settlementAmount: 'Settlement Amount',
    textu1rd: 'Floor Amount',
    textvd7y: 'Show ID Details',
    textvjsy: 'Signing Subject',
    texto62c: 'Show Contact',
    textomko: 'Attachment URL',
    text2egl: 'QueryInformation',
    textzjva: 'Signing EntityInformation',
    text62wo: 'Area Release Info',
    textkgfm: 'Area Info',
    text9gt7: 'Released Campus Info',
    textla60: 'Top Breadcrumb',
    textmtpl: 'Title',
    textbg1j: 'Organization Info',
    textthsl: 'Organization Entity',
    textr61k: 'Organization',
    textdhsa: 'Organization Nature',
    textjl09: 'Organization Type',
    textqc3d: 'Organization Name',
    textdujb: 'Organization Rating',
    textdtnm: 'Organization Address',
    textzgvh: 'View Location',
    textgey9: 'Support Staff',
    textgwp5: 'Handover Status',
    text5l3n: 'Formal Handover',
    textbhjz: 'Pre-Handover',
    text9ln6: 'Opening Status',
    textelby: 'Reason',
    textavtk: 'Real Name',
    text1hmx: 'Contact',
    text6rts: 'Expand',
    textfwb7: 'Collapse',
    textngln: 'ContactInformation',
    textqtqr: 'Contact Name',
    textzjio: 'Contact Phone',
    textu9uw: 'Contact Email',
    textwkrh: 'Organization Basic Info',
    textoncj: 'Recruitment Phone',
    textk7b6: 'RecruitEmail',
    textf4vr: 'Organization Area',
    textrpxj: 'Classroom Count',
    textlojp: 'Max Capacity',
    textu0d7: 'Rent',
    textfc2o: 'Renovation Status',
    text767v: 'Not Renovated',
    textlfac: 'Renovating',
    textkk3y: 'Renovation Done',
    textrp5n: 'Invoice Title',
    text4ch9: 'Phone',
    texto9g2: 'Bank Name',
    text618k: 'Consignee',
    text8k5h: 'Consignee Contact',
    textzm06: 'Delivery Address',
    textfn2h: 'Account Type',
    textao89: 'Individual',
    texta3pj: 'Company',
    textcnn5: 'Account Name',
    textxh2u: 'Unit Name',
    textrran: 'Bank',
    textos3a: 'Organization Textbook Version',
    texts3x4: 'Textbook Version Info',
    textq675: 'Organization Device Info',
    textpuci: 'Computer',
    text6iyx: 'Phone',
    text73vu: 'Attendance Machine',
    text8f7w: 'Writing Pad',
    textd0tr: 'Camera',
    textye7k: 'Pricing & System Info',
    text39z3: 'Charge Status',
    text40sa: 'Charge',
    textm162: 'Free',
    textlea8: 'Pricing Plan',
    text8655: 'Pricing Factor',
    textadyx: 'HQ Online Payment',
    textlnz6: 'Enable',
    close: 'Close',
    textrnuy: 'Auto Recharge Ratio',
    texth9ug: 'Merchant',
    textxihj: 'Organization Tag',
    textr4ty: 'Enable Small Class',
    textbo6m: 'Small Class Primary Price',
    textwsjq: 'Small Class Junior Price',
    textzaqr: 'Small Class Senior Price',
    textl0oq: 'Small Class Primary Pricing',
    textu62b: 'Small Class Junior Pricing',
    text5orh: 'Small Class Senior Pricing',
    textitua: 'Enable Large Class',
    textcyos: 'Large Class Primary Pricing',
    text3qnh: 'Large Class Junior Pricing',
    text699x: 'Large Class Senior Pricing',
    textwgk1: 'HQ',
    text6gu8: 'Placement Plan',
    text0pv7: 'Participate',
    textfofj: 'Not Participate',
    textxg3q: 'Claim Limit',
    day: 'Daily',
    textwfvm: 'Material Info',
    text1ewz: 'Attachment',
    text08n9: 'Material',
    text3hl2: 'Output',
    textaq4e: 'Basic Info',
    textlm5i: 'Handover Info',
    textwuc5: 'Organization Address Location',
    text460s: 'Device Info',
    textc5i7: 'Textbook Version',
    texte7wu: 'Material Type',
    textz96b: 'Material Name',
    text6sic: 'Uploader',
    textlihh: 'Dev Test',
    textsq7r: 'Component Function',
    text1quf: 'QueryInformation',
    text2dm7: 'Query Organization Handover',
    textq34k: 'QueryContactInformation',
    textulvb: 'Query Organization Basic Info',
    textz8kw: 'Query Pricing & System Info',
    textblng: 'Query Organization Material',
    text5y1x: 'Area Info',
    textyqix: 'Keyword',
    textvegn: 'Area Name',
    textpxms: 'Edit Area',
    textnn3r: 'Edit Campus Area',
    text8017: 'Reward Ratio',
    textw5hw: 'Total Count',
    textpatt: 'TBD',
    text85yl: 'Unsubscribe',
    text7sbf: 'LeadInformation',
    textl2db: 'LeadStatus',
    textzbos: 'Referral Agent Info',
    textctrb: 'Referrer',
    texttfim: 'Referral Agent Name',
    textbp5e: 'Referrer Region',
    textn7fx: 'Referrer Name',
    textgqvh: 'Referrer Phone',
    texttn6m: 'Customer Screenshot',
    textluet: 'Reward Method Info',
    text2gmn: 'Reward Method',
    textg4a9: 'Withdrawal Agent',
    textjq5l: 'Withdrawal Agent Name',
    textxrvp: 'SubmitAgentInformation',
    text6sv4: 'Submitter Agent',
    text8rfe: 'SubmitAgent Name',
    text2r13: 'Submitter Region',
    texttx22: 'CustomerInformation',
    text9eht: 'Customer Phone',
    text54zu: 'Customer Region',
    textzb3a: 'Customer Background',
    textdr39: 'Follow-up Expansion Info',
    textpe5s: 'Follow-up Expansion Name',
    texttkfu: 'Expansion Screenshot',
    textoryd: 'Review Info',
    text3oqz: 'Review Comment',
    applicationTime: 'Application Time',
    submitTime: 'Submit Time',
    auditTime: 'Audit Time',
    pleaseSelectLeadStatus: 'Please select lead status',
    introducerAgentId: 'Referral Agent ID',
    introducerAgentName: 'Referral Agent Name',
    introducerAgentRegion: 'Referral Agent Region',
    withdrawAgentId: 'Withdrawal Agent ID',
    withdrawAgentName: 'Withdrawal Agent Name',
    pleaseSelectRewardMethod: 'Please select reward method',
    textxphb: 'Channel Agent Application',
    textoqrs: 'View Agreement',
    details: 'Details',
    texthfj9: 'Upgrade Dialog',
    texth9mi: 'Upgrade to',
    text8wsx: 'Required Quota',
    text64ye: 'Current Level',
    textzsod: 'Available Quota',
    texta5ra: 'Total Count',
    textn4ks: 'Click',
    confirm: 'Confirm',
    textlitm: 'Then submit to Nuwa',
    texteair: 'Only',
    texts9bh: 'Level+ Dealers',
    agent2: 'Agent',
    textctyl: 'Can Apply Channel Agent',
    text2e0n: 'Your Current Dealer',
    textd2u8: 'Belongs to',
    textzmer: 'Not Supported',
    texttzhc: 'Unsubscribe',
    textt2ad: 'Account Change Notice',
    textu12m: 'Total Count',
    textoxkw: 'Unsubscribe',
    // Advertisement
    advertName: 'Advertisement Name',
    confirmAdvertStatus: 'Confirm',
    auto_1_381101ee: "Purchase Order No.1",
    auto_2_2f5d5b8b: "Purchase Product2",
    auto_3_e6944985: "Quantity3",
    auto_4_117e0685: "Purchase Amount4",
    auto_5_72a6f3c8: "Gold Account Pay Amount5",
    auto_6_2263f7d9: "Voucher Account Pay Amount6",
    auto_7_e571c196: "Cash Pay Amount7",
    auto_8_5cc0a006: "Pay Method8",
    auto_9_272f0d73: "Last Pay Time9",
    auto_10_a40d69ff: "Operator10",
    auto_11_4b30c5c0: "Remark11",
    auto_12_d632128e: "Agent12",
    auto_13_d103286a: "Agent Name13",
    auto_14_5c3b120e: "Service Region14",
    auto_15_6ba7cab2: "Total Payment15",
    auto_16_79db4cda: "Paid Payment Amount16",
    auto_17_236f815d: "Retention Balance17",
    auto_18_58acb097: "Status18",
    auto_19_e4e29a3c: "Period19"
  }
}
